import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Home from './Home';
import PropertyDetail from './components/PropertyDetail';
import PropertyTour from './components/PropertyTour';
import VirtualTours from './components/VirtualTours';
import AerialDemo from './components/AerialDemo';
import NotFound from './components/NotFound';

const App = () => {  
  return (  
    <Router>  
      <div className="App">  
        <Routes>
          <Route path="/" element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Home />
            </motion.div>
          } />
          <Route path="/propiedad/:id" element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <PropertyDetail />
            </motion.div>
          } />
          <Route path="/propiedad/:id/360" element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <PropertyTour />
            </motion.div>
          } />
          <Route path="/tours-virtuales" element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <VirtualTours />
            </motion.div>
          } />
          <Route path="/recorrido-aereo-1" element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <AerialDemo />
            </motion.div>
          } />
          <Route path="*" element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <NotFound />
            </motion.div>
          } />
        </Routes>
      </div>  
    </Router>  
  );  
};  

export default App;
